<script setup>
import AudioNotifications from './AudioNotifications.vue';
import NotificationPreferences from './NotificationPreferences.vue';
import SectionLayout from '../account/components/SectionLayout.vue';
import BaseSettingsHeader from '../components/BaseSettingsHeader.vue';
import Policy from 'dashboard/components/policy.vue';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

const permissions = [...ROLES, ...CONVERSATION_PERMISSIONS];
</script>

<template>
  <div class="flex w-full min-w-0 flex-col">
    <BaseSettingsHeader
      :title="$t('PROFILE_SETTINGS.NOTIFICATIONS_PAGE.TITLE')"
      :description="$t('PROFILE_SETTINGS.NOTIFICATIONS_PAGE.DESCRIPTION')"
    />
    <div class="w-full px-8 md:px-10">
      <div class="max-w-2xl">
        <Policy :permissions="permissions">
          <SectionLayout
            :title="
              $t('PROFILE_SETTINGS.FORM.AUDIO_NOTIFICATIONS_SECTION.TITLE')
            "
            :description="
              $t('PROFILE_SETTINGS.FORM.AUDIO_NOTIFICATIONS_SECTION.NOTE')
            "
            class="!pt-0"
          >
            <AudioNotifications />
          </SectionLayout>
        </Policy>
        <Policy :permissions="permissions">
          <SectionLayout
            with-border
            :title="$t('PROFILE_SETTINGS.FORM.NOTIFICATIONS.TITLE')"
            description=""
          >
            <NotificationPreferences />
          </SectionLayout>
        </Policy>
      </div>
    </div>
  </div>
</template>
